import React from 'react';
import { ModalSliderHeader } from './ModalSliderHeader';
import Drawer from '@material-ui/core/Drawer';

type ModalProps = {
    header: string,
    button: Element,
    close?: boolean,
    controls?: boolean,
    closeClick?: any,
    backClick?: any,
    searchClick?: any,
    sortClick?: any,
    children?: any,
    open?: boolean
}

export const ModalSlideout = ({ ...props }: ModalProps) => {
    const [open, setOpen] = React.useState(props.open || false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        props.closeClick && props.closeClick();
        setOpen(false);
    };


    return (
        <div className="modal-slideout">
            <div className="sis-button" onClick={handleClickOpen}>
                {props.button}
            </div>
            <Drawer anchor="right" open={open} onClose={handleClose} PaperProps={{
                style: {
                    backgroundColor: '#EDEDED'
                },
            }}>
                <ModalSliderHeader header={props.header} close={props.close} controls={props.controls} closeClick={handleClose} backClick={props.backClick} sortClick={props.sortClick} searchClick={props.sortClick} />
                <div className="modal-slideout-container">
                    {props.children}
                </div>
            </Drawer>
        </div>
    );
}